import { differenceInSeconds, isValid, parse, set } from "date-fns";

export function getDriverTimeStatus(timeStr: string, durationSeconds?: number): 'success' | 'caution' | 'warning' | 'default' {
  if (!Number.isFinite(durationSeconds)) {
    return 'default';
  }

  const parseTimeStringToSeconds = (input: string): number | null => {
    const [hoursPart = '', minutesPart = ''] = input.split(':');
    const hours = parseInt(hoursPart.replace('h', ''), 10) || 0;
    const minutes = parseInt(minutesPart.replace('m', ''), 10) || 0;

    if (isNaN(hours) || isNaN(minutes)) {
      return null;
    }

    return (hours * 3600) + (minutes * 60);
  };

  const elapsedSeconds = parseTimeStringToSeconds(timeStr);

  if (elapsedSeconds === null) {
    return 'default';
  }

  const percentage = elapsedSeconds / durationSeconds!;

  if (percentage <= 0.8) {
    return 'success';
  }

  if (percentage <= 0.9) {
    return 'caution';
  }
  return 'warning';
}

export function getDriverTableTimeStatusColor(signIn: string, startTime: string, driverTimerSettingsTimeThreshold: number = 0):
  'success' | 'caution' | 'warning' | 'default' | null {
  // Return null if no valid startTime or no threshold set
  if (!startTime || driverTimerSettingsTimeThreshold === 0 || signIn === '0001-01-01T00:00:00.000Z') {
    return null;
  }

  const signInDate = new Date(signIn);
  let startDateTime;
  let hasExpectedSignInDate = false;
  const timeOnlyDate = parse(startTime, 'HH:mm:ss', new Date());
  if (isValid(timeOnlyDate)) {
    hasExpectedSignInDate = true;
    const [hours, minutes, seconds] = startTime.split(':').map(Number);
    startDateTime = set(signInDate, { hours, minutes, seconds });
  } else {
    startDateTime = new Date(startTime)
  }

  if (hasExpectedSignInDate) {
    const currentDate = new Date();
    if (signInDate < startDateTime && currentDate >= startDateTime) {
      return 'success'; // signed in before start time and current time is past start time
    }
    if (signInDate < startDateTime && currentDate < startDateTime) {
      return 'default'; // signed in before start time and current time is before start time
    }
  }

  const diffInSeconds = differenceInSeconds(signInDate, startDateTime);
  if (signInDate < startDateTime) {
    return 'default';  // signed in before the start time
  } else if (diffInSeconds <= driverTimerSettingsTimeThreshold / 2) {
    return 'success'; // Signed in on time or within first half of the threshold
  } else if (diffInSeconds <= driverTimerSettingsTimeThreshold) {
    return 'caution'; // Signed in after half the threshold
  } else {
    return 'warning'; // Signed in after the full threshold
  }
}